import { combineReducers } from '@reduxjs/toolkit'
import booking from './bookingSlice'

const reducer = combineReducers({
    booking,
})

export default reducer
